export const styles = {
  input: {
    display: "none"
  }
};
